import React,{useEffect,useState} from 'react'
import { Box,Button,Stack,TextField,Typography} from '@mui/material'
import { exerciseOptions,fetchData } from '../utils/fetchdata'
import '../styles/HeroBanner.css';
import HorizontalScrollbar from './HorizontalScrollbar';

const SearchExercises = ({setExercises,bodyPart,setBodyPart}) => {
  const[search,setSearch]=useState(''); 
  const [bodyParts,setBodyParts]=useState([]);

  // This section is for sliding mmenu
  useEffect(()=>{
    const fetchExercisesData=async()=>{
      const bodyPartsData = await fetchData('https://exercisedb.p.rapidapi.com/exercises/bodyPartList',exerciseOptions);
      setBodyParts(['all',...bodyPartsData])
    }
    fetchExercisesData();
  },[])

  const handleSearch=async()=>{
    if(search){
      const exerciseData=await fetchData('https://exercisedb.p.rapidapi.com/exercises',exerciseOptions);
      const searchedExercises=exerciseData.filter(
     (exercise)=>exercise.name.toLowerCase().includes(search) //(exercise)=we get each specific exerise
        || exercise.target.toLowerCase().includes(search)
        || exercise.equipment.toLowerCase().includes(search)
        || exercise.bodyPart.toLowerCase().includes(search)
      );
      setSearch(''); //it clears the search after clicking search button
      setExercises(searchedExercises); //exercises =searchedExercises
    } 
  }
  return (
    <Stack alignItems='center' mt='37px'justifyContent='center' p='20px'>
      <Typography fontWeight={700} sx={{
        fontSize:{lg:'44px',xs:'25px'},
        mt:{xs:'100px'},ml:{xs:'22px'}
      }} mb='50px' textAlign='center'>
        Awesome Exercises You <br/> Should Know
      </Typography>
      <Box position='relative' mb='72px'>
<TextField
sx={{
  input:{
    fontWeight:'700',border:'none', borderRadius:'4px'
  },
  ml:{xs:'40px'},
  width:{lg:'1000px',xs:'350px'},
  backgroundColor:'#fff',
  borderRadius:'40px'
}}
height='76px'
value={search}
onChange={(e)=> setSearch(e.target.value.toLowerCase())}
placeholder="Search Exercises"
type='text'/>
<Button className='search-btn'
sx={{
  bgcolor:'#FF2625',
  color:"#fff",
  textTransform:'none',
  width:{lg:'170px',xs:'80px'},
  fontSize:{lg:'20px',xs:'14px'},
  height:'56px',
  position:'absolute',
  right:'0px'
}}
onClick={handleSearch}
>Search</Button>
      </Box>
      <Box sx={{position:'relative',width:'100%',p:'20px'}}>
        <HorizontalScrollbar data={bodyParts}
        bodyPart={bodyPart} //this is an selected bodypart on which we clicked on the icon
        setBodyPart={setBodyPart} 
        isBodyParts
        />
      </Box>
    </Stack>
  )
}

export default SearchExercises